import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { HomeService } from '../_services/home.service';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { MatStepper } from '@angular/material/stepper';
import Swal from 'sweetalert2';
import { environmentbasic } from 'src/environments/environment-basic';
import { ErrorMessageService } from '../services/error-message.service';
import { ToastrService } from 'ngx-toastr';
import { EmailverifyComponent } from '../verifymodel/emailverify/emailverify.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../_services/auth.service';
@Component({
  selector: 'app-my-rent-buy-property',
  templateUrl: './my-rent-buy-property.component.html',
  styleUrls: ['./my-rent-buy-property.component.scss']
})
export class MyRentBuyPropertyComponent implements OnInit {
  @ViewChild(MatStepper) stepper: MatStepper;
  selectedFiles: File[] = [];
  selectedUnit: number = 1;
  selectedWidth: string = '';
  selectedSize: string = '';
  isFocused: boolean = false;
  cityId: any;
  cityName: any;
  calculatedWidth: string = '';
  calculatedSize: string = '';
  inputAsking: number = 0;
  inputWidth: string = '';
  inputSize: string = '';
  selectedFileNames: string[] = [];
  isLinear = true // ✅
  countryId = 259;
  stateList: any[] = [];
  cityDataList: any[] = [];
  cityDataListfirst: any[] = [];
  id: any;
  stateId: number;
  stateName: string;
  data: any;
  cityid: number;
  payload: any;
  paramsData: any;
  Propertyid: string;
  pdfurl: any;
  selectedCity: any = null;
  selectedCityId1: number;
  selectedCityId: any
  media: any = [];
  length: number = 1;
  image: any = [];
  Urls: string[] = [];
  selectedVideoFiles: File[] = [];
  selectedVideoFileNames: string[] = [];
  uploadedVideos: string[] = [];
  videoItems: { loading: boolean; purpose: string }[] = [];

  imageItems: any[] = [
    {
      constrolName: 'imageUrls',
      purpose: 'propertiesImage',
      index: 0,
      url: '',
      type: 'image',
      controlArray: true,
      loading: false,
      linkadd: false,
    },
  ];
  firstFormValue: any
  feature: any;
  uploadedImages: any[] = [];
  featureResponsePayload: any;
  featureResponse: any;
  citySelected = false;
  filteredpropertyTypes = [];

  propertyTypes = {
    Residential: [
      { value: 'flat/apartment', label: 'Flat/Apartment' },
      { value: 'villa', label: 'Villa' },
      { value: 'independenthouse', label: 'Independent House' },
      { value: 'builderfloor', label: 'Builder Floor' },
      { value: 'other', label: 'Other' }
    ],
    Commercial: [
      { value: 'office-space', label: 'Office Space' },
      { value: 'office-itpark-sez', label: 'Office in IT Park/SEZ' },
      { value: 'shop', label: 'Shop' },
      { value: 'warehouse/godown', label: 'Warehouse/Godown' },
      { value: 'industrialland', label: 'Industrial Land' },
      { value: 'industrialbuilding', label: 'Industrial Building' },
      { value: 'showroom', label: 'Showroom' },
      { value: 'industrialshed', label: 'Industrial Shed' },
      { value: 'other', label: 'Other' }
    ]
  };

  constructor(
    private _formBuilder: FormBuilder,
    private homeService: HomeService,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private errorMessageService: ErrorMessageService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private authService: AuthService,
  ) { }


  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.Propertyid = params['id'];
      if (this.Propertyid) {
        this.propertById();
      } else {
        console.error('No Propertyid found in query params');
      }
    });
    const emptysearch = ''
    this.getCitybyCountryId(emptysearch);
    this.onTypeChange(this.firstFormGroup.get('type')?.value);
  }

  firstFormGroup = this._formBuilder.group({
    postType: ['rent'],
    type: ['Residential', Validators.required],
    furnishing: ['', Validators.required],
    propertyType: ['', Validators.required],
    title: ['', Validators.required],
    description: ['', Validators.required],
    address: ['', Validators.required],
    area: ['', Validators.required],
    cityName: ['', Validators.required],
    stateId: ['', Validators.required],
    status: ['draft'],
  });

  secondFormGroup = this._formBuilder.group({
    amenities: [[], Validators.required],
    buildupArea: ['', Validators.required],
    coverArea: ['', Validators.required],
    construction: ['', Validators.required],
    widthOfFacingRoadUnit: ['', Validators.required],
    totalFloors: ['', Validators.required],
    waterSource: ['', Validators.required],
    propertyRentPrice: ['', Validators.required],
    maintenanceCharge: ['', Validators.required],
  });


  thirdFormGroup = this._formBuilder.group({
    imageUrls: [''],
    videoUrls: [''],
  });


  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.selectedFiles = Array.from(input.files);
      this.selectedFileNames = this.selectedFiles.map((file) => file.name);
    }
  }

  onCitySearch(event: any) {
    const searchValue = event.target.value;
    if (searchValue.length > -1) {
      this.getCitybyCountryId(searchValue);
    } else {
      this.getCitybyCountryId(null);
    }
  }

  getCitybyCountryId(searchText: string) {
    this.homeService.searchCity(searchText).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.cityDataList = response.payload;

          console.log(this.cityDataList);
        } else {
          console.error('Failed to fetch city data:', response);
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        if (message) {
          let errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }
      }
    );
  }


  displayCityName(city: any): string {
    if (!city) return '';
    return typeof city === 'object' && 'name' in city ? city.name : String(city);
  }
  onCityChange(event: any) {
    console.log('onCityChange triggered');
    this.selectedCity = event.option.value;
    console.log("this.selectedCity", this.selectedCity);
    this.selectedCityId1 = this.selectedCity.id;
    this.selectedCityId = this.selectedCity.name;
    console.log('selectedCityId:', this.selectedCityId1);
    this.citySelected = true;
    this.getStateByCityId(this.selectedCityId1);
  }

  getStateByCityId(cityId: number) {
    this.homeService.searchstate(cityId).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.stateId = response.payload.stateId;
          this.stateName = response.payload.stateName;
          console.log(this.stateId, this.stateName);
          this.cd.detectChanges();
          this.firstFormGroup.patchValue({
            stateId: this.stateId,
          });
          this.cd.detectChanges();
          console.log('stId', this.stateId);
        } else {
          console.error('Failed to fetch state data:', response);
          this.firstFormGroup.patchValue({
            stateId: null,
          });
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        if (message) {
          let errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }
      }
    );
  }

  onStepChange(event: any) {
    const stepIndex = event.selectedIndex;
    if (stepIndex === 1 && this.firstFormGroup.invalid) {
      event.preventDefault();
      this.firstFormGroup.markAllAsTouched();
      return;
    }
    if (stepIndex === 2 && this.secondFormGroup.invalid) {
      event.preventDefault();
      this.secondFormGroup.markAllAsTouched();
      return;
    }
    if (stepIndex === 3 && this.thirdFormGroup.invalid) {
      event.preventDefault();
      this.thirdFormGroup.markAllAsTouched();
      return;
    }
  }

  onSubmit() {
    const formGroups = [this.firstFormGroup, this.secondFormGroup, this.thirdFormGroup];

    formGroups.forEach(formGroup => {
      const controls = formGroup.controls;
      for (const i in controls) {
        if (controls.hasOwnProperty(i)) {
          controls[i].markAsDirty();
          controls[i].updateValueAndValidity();
        }
      }
    });

    if (formGroups.every(formGroup => formGroup.valid)) {
      let payload = {
        ...this.firstFormGroup.value,
        ...this.secondFormGroup.value,
        ...this.thirdFormGroup.value,
        imageUrls: this.uploadedImages,
        videoUrls: this.uploadedVideos
      };

      if (typeof payload.cityName === 'object' && payload.cityName !== null) {
        payload.cityName = payload.cityName.name;
      }

      console.log('Combined Payload:', payload);


      if (this.Propertyid) {
        this.UpdateProperty(payload, this.Propertyid)
      }
    }
  }

  onTypeChange(selectedType: string): void {
    this.filteredpropertyTypes = this.propertyTypes[selectedType] || [];
    this.firstFormGroup.get('propertyType')?.reset();
  }
  propertById() {
    this.homeService.getPropertyById(this.Propertyid).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          console.log('response', response);
          this.data = response?.payload;
          console.log('data', this.data);
          let selectedCityId = response?.payload?.cityId;
          this.getStateByCityId(selectedCityId);
          this.stateId = response?.payload?.stateId;
          this.cityName = response?.payload?.cityName;
          this.feature = response?.payload?.feature
          console.log("this.data", this.data)

          const mediaGroup = this.data.mediaGroup || [];
          const images = mediaGroup
            .filter(media => media.mediaType === 'IMAGE')
            .map(media => media.url);
          const videos = mediaGroup
            .filter(media => media.mediaType === 'VIDEO')
            .map(media => media.url);

          // Display in component
          this.uploadedImages = images;
          this.uploadedVideos = videos;
          this.firstFormGroup.patchValue(this.data);
          this.secondFormGroup.patchValue(this.data);

          this.thirdFormGroup.patchValue({
            imageUrls: images,
            videoUrls: videos
          });

          console.log('feature', this.feature);
        } else if (response && response.status === 'EXCEPTION') {
          if (response['message']) {
            let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
            this.toastr.error(errorMessage, 'Error');
          }
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        if (message) {
          let errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }


      }
    );
  }

  UpdateProperty(payload: any, id: any) {
    const profileData = localStorage.getItem('UserProfile');

    // if (profileData) {
    //   const parsedData = JSON.parse(profileData);
    //   const useremail = parsedData?.payload?.email;
    //   const isemailverified = parsedData?.payload?.isEmailVerified;

    //   // Check if email is not verified and status is active
    //   if (payload.status === 'active' && isemailverified !== 1) {
    //     // Send OTP and show modal; on success, continue property update
    //     this.onVerifyEmail(useremail, () => {
    //       this.submitProperty(payload, id);
    //     });
    //     return; // Don't continue until email is verified
    //   }
    // }

    // If email is verified or not required, continue
    this.submitProperty(payload, id);
  }

  submitProperty(payload: any, id: any) {

    this.homeService.Updateroperty(payload, id).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          console.log('response',response.payload)
          localStorage.setItem('allcityId', response.payload?.cityId);
          localStorage.setItem('allstateId', response.payload?.stateId);
          localStorage.setItem('selectedCityName', response.payload?.cityName);
          localStorage.setItem('selectedCityId', response.payload?.cityId);
          this.toastr.success('Property Updated Successfully', 'Success');
          this.router.navigate(['/UserProperty']);
        } else {
          const errorMessage = this.errorMessageService.getErrorMessage(response.message || 'Something went wrong');
          this.toastr.error(errorMessage, 'Update Failed');
        }
      },
      error: (error) => {
        const errorMessage = this.errorMessageService.getErrorMessage(error.message || 'An unexpected error occurred');
        this.toastr.error(errorMessage, 'Error');
      }
    });
  }

  onVerifyEmail(email_Id: string, onVerifiedCallback?: () => void) {
    console.log("email_Id", email_Id);

    if (!email_Id) {
      console.error("Email ID is empty or undefined.");
      return;
    }

    this.authService.sendemailotp(email_Id).subscribe(
      (res: any) => {
        console.log('API Response:', res);

        if (res && res.status === 'SUCCESS') {
          this.toastr.success('OTP Sent successfully!', 'Success');
          this.showModal(email_Id, onVerifiedCallback); // ✅ Show modal after OTP sent
        }
        else if (res && res.status === 'EXCEPTION') {
          const errorMessage = this.errorMessageService.getErrorMessage(res.message);
          this.toastr.error(errorMessage, 'Error');
        }
        else if (res?.message) {
          const errorMessage = this.errorMessageService.getErrorMessage(res.message);
          this.toastr.error(errorMessage, 'Error');
        }
      },
      (error) => {
        const message = error?.error?.message || 'Failed to send OTP';
        const errorMessage = this.errorMessageService.getErrorMessage(message);
        this.toastr.error(errorMessage, 'Error');
      }
    );
  }

  showModal(email: string, onVerifiedCallback?: () => void): void {
    const dialogRef = this.dialog.open(EmailverifyComponent, {
      width: '450px',
      data: { email: email },
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'verified') {
        this.toastr.success('Email Verified Successfully!', 'Success');
        if (onVerifiedCallback) {
          onVerifiedCallback(); // ✅ Continue with submission
        }
      } else {
        this.toastr.info('Email verification is required to proceed.', 'Verification Incomplete');
      }
    });
  }



  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }
  handleCancel() {
    const id = this.route.snapshot.queryParamMap.get('id')
    if (id) {
      this.router.navigate(['/UserProperty'])
    }
    else {
      this.router.navigate(['/home-property'])
    }

  }
  handleChange(event: any): void {
    const files = event.target.files;
    if (files && files.length) {
      for (let i = 0; i < files.length; i++) {
        this.selectedFiles.push(files[i]);
        this.selectedFileNames.push(files[i].name);
        this.imageItems.push({ loading: true, purpose: 'propertiesImage' });
      }
      this.cd.detectChanges();
    }
  }

  uploadFiles(): void {
    if (this.selectedFiles.length) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        const selectedFile = this.selectedFiles[i];
        const type = this.imageItems[i];
        const mimeType = selectedFile.type;
        const purpose = type.purpose;

        this.homeService.getMediaData(purpose, mimeType, selectedFile)
          .pipe(finalize(() => { this.imageItems[i].loading = false; }))
          .subscribe((res: any) => {
            const media_type = (purpose === 'propertiesImage') ? 'image' : ((purpose === 'shopVideo') ? 'video' : 'logo');
            this.uploadedImages.push(res.url);
            this.cd.detectChanges();
          });
      }
      this.clearFileInput();
    }
  }

  clearFileInput(): void {
    this.selectedFiles = [];
    this.selectedFileNames = [];
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.value = ''; // Clear the file input value
    this.cd.detectChanges();
  }
  removeImage(index: number): void {
    this.uploadedImages.splice(index, 1);
    this.selectedFiles.splice(index, 1);
    this.selectedFileNames.splice(index, 1);
    this.imageItems.splice(index, 1);
    this.cd.detectChanges();
  }





  triggerVideoInput(): void {
    const videoInput = document.getElementById('videoInput') as HTMLInputElement;
    videoInput.click();
  }

  handleVideoChange(event: any): void {
    const files = event.target.files;
    if (files && files.length) {
      for (let i = 0; i < files.length; i++) {
        this.selectedVideoFiles.push(files[i]);
        this.selectedVideoFileNames.push(files[i].name);
        this.videoItems.push({ loading: true, purpose: 'propertiesImage' });
      }
      this.cd.detectChanges();
    }
  }

  uploadVideoFiles(): void {
    if (this.selectedVideoFiles.length) {
      for (let i = 0; i < this.selectedVideoFiles.length; i++) {
        const selectedFile = this.selectedVideoFiles[i];
        const type = this.videoItems[i];
        const mimeType = selectedFile.type;
        const purpose = type.purpose;

        this.homeService.getMediaData(purpose, mimeType, selectedFile)
          .pipe(finalize(() => { this.videoItems[i].loading = false; }))
          .subscribe((res: any) => {
            const media_type = 'video'; // Directly set video
            this.uploadedVideos.push(res.url);
            this.cd.detectChanges();
          });
      }
      this.clearVideoFileInput();
    }
  }

  clearVideoFileInput(): void {
    this.selectedVideoFiles = [];
    this.selectedVideoFileNames = [];
    const videoInput = document.getElementById('videoInput') as HTMLInputElement;
    videoInput.value = '';
    this.cd.detectChanges();
  }

  removeVideo(index: number): void {
    this.uploadedVideos.splice(index, 1);
    this.selectedVideoFiles.splice(index, 1);
    this.selectedVideoFileNames.splice(index, 1);
    this.videoItems.splice(index, 1);
    this.cd.detectChanges();
  }

  updateImages() {
    const modifiedPayload = { ...this.featureResponsePayload };

    const fieldsToRemove = ['mediaGroup', 'user', 'updatedAt'];
    fieldsToRemove.forEach(field => {
      delete modifiedPayload[field];
    });

    const payloadWithFeature = {
      ...modifiedPayload,
      imageUrls: this.uploadedImages
    };

    this.homeService.Updateroperty(payloadWithFeature, this.Propertyid).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          console.log("response>>>>", response);
          const urlId = this.route.snapshot.queryParams['id'];
          this.toastr.success('Property Added Successfully', 'Success');
          this.router.navigate(['/property-details'], { queryParams: { id: this.Propertyid } });
          console.log('response', response);
        }
        else if (response && response.status === 'EXCEPTION') {
          if (response['message']) {
            let errorMessage = this.errorMessageService.getErrorMessage(response['message']);
            this.toastr.error(errorMessage, 'Error');
          }
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        if (message) {
          let errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }


      }
    );
  }
  clearSelect(controlName: string) {
    this.thirdFormGroup.controls[controlName].setValue(null);
  }
  validateNumberInput(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }
  get description() {
    return this.firstFormGroup.get('description');
  }
}
